module.exports = __webpack_public_path__ + "static/media/level4.39f0310a.jpg";